import { useTranslation } from "react-i18next";
import usePermissions from "../../../hooks/usePermissions";
import { DropdownMenuItem } from "./DropdownMenu";
import { Pencil } from "lucide-react";

const DropdownMenuItemEdition = ({ onEditHandler }) => {
  const { t } = useTranslation();
  const permissions = usePermissions();
  const hasEditPermissions = permissions.canEdit();

  return (
    hasEditPermissions && (
      <DropdownMenuItem
        className="hover:cursor-pointer flex flex-row items-center gap-x-2"
        onClick={onEditHandler}
      >
        <Pencil className="h-4 w-4" />
        {t("defaults.editLabel")}
      </DropdownMenuItem>
    )
  );
};

export default DropdownMenuItemEdition;
